/*
    This differs from device_pane_layout in that it isn't meant to have a devices list.

    Ideally the two could be used for the same stuff, and you'd just pass "no_device_pane" or whatever,
    but that's not how things are set up.
*/

import _ from 'underscore';
import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import DeviceInfoView from '@/views/device_breadcrumb_info_view';
import LoggingView from '@/views/logging_view';
import logs_controls_templ from '@/../templates/ide-device-info.hbs';

    var layout_template = '<div class="controls-region device-info-region current-device"></div><div class="log"></div>';
    var globalCh = Radio.channel('global');
    var ga = globalCh.request('app_options', 'ga_account');

    var device_logs_layout = Marionette.View.extend({
        template: Handlebars.compile(layout_template),
        className: 'devices-pane',
        regions: {
            controls: '.controls-region',
            logs: '.log',
        },
        ui: {
            clear_log_button: '.controls .clear',
            pause_button: '.controls .pause',
            lock_icon: '.controls .lock',
            expand_button: '.controls .expand',
            collapse_button: '.controls .collapse'
        },
        events: {
            'click @ui.assign_btn': 'show_assign_devices_dialog',
            'click @ui.clear_log_button': 'onclick_clear_log_button',
            'click @ui.pause_button': 'onclick_pause_button'
        },
        initialize: function () {
            // create local storage key value
            if (!localStorage.getItem('paused_devices')) {
                localStorage.setItem('paused_devices', JSON.stringify(new Array));
            }
        },
        // This is basically a toggle function for our local storage key invoked during on_click_pause
        logging_enabled: function () {
            var paused_devices = JSON.parse(localStorage.getItem('paused_devices'));
            // If not included in the local storage array, its currently enabled. return true
            if (!paused_devices.includes(this.model.get('id'))) {
                return true;
            } else {
                return false;
            }
        },
        toggle_logging: function() {
            var paused_devices = JSON.parse(localStorage.getItem('paused_devices'));
            // If not included in the local storage array, its currently enabled. return true
            if (!paused_devices.includes(this.model.get('id'))) {
                paused_devices.push(this.model.get('id'));
                localStorage.setItem('paused_devices', JSON.stringify(paused_devices));
                return true;
                // If its in the array its currently disabled. return false
            } else {
                paused_devices = _.without(paused_devices, this.model.get('id'));
                localStorage.setItem('paused_devices', JSON.stringify(paused_devices));
                return false;
            }
        },
        build_regions: function (device) {
            this.show_device_info(device);
            this.show_logs(device);

            this.active_device = device;
        },
        show_device_info: function (device) {
            var device_logs_control_view = new DeviceInfoView({
                template: Handlebars.compile(logs_controls_templ),
                className: 'header',
                model: device,
            });

            this.showChildView('controls', device_logs_control_view);
        },
        show_logs: function (device) {
            var logging_view = new LoggingView({
                model: device,
            });
            this.listenTo(logging_view, 'lock', this.log_locked);
            this.listenTo(logging_view, 'unlock', this.log_unlocked);
            this.showChildView('logs', logging_view);
            this.showChildView('logs', logging_view);
        },
        onRender: function () {
            this.ui.clear_log_button.tooltip();
            this.ui.pause_button.tooltip();
            this.ui.lock_icon.tooltip();

            this.build_regions(this.model);
        },
        onclick_clear_log_button: function () {
            if (ga) {
                window.ga('send', 'event', 'logsPane', 'Click Clear Log Button');
            }
            var logging_view = this.getRegion('logs').currentView;
            if (!logging_view || !logging_view.clear_log) { return; }

            logging_view.clear_log();
        },
        onclick_pause_button: function () {
            if (ga) {
                window.ga('send', 'event', 'logsPane', 'Click Pause Button');
            }

            var logging_view = this.getRegion('logs').currentView;
            if (!logging_view || !logging_view.enable_log) { return; }
            
            // If enabled, disable in logging_view
            if (this.logging_enabled()) {
                this.ui.pause_button.addClass('active');
                logging_view.disable_log(this.model);
            } else {
                this.ui.pause_button.removeClass('active');
                logging_view.enable_log(this.model);
            }
            this.toggle_logging();
        },
        log_locked: function () {
            if (ga) {
                window.ga('send', 'event', 'logsPane', 'Log Locked');
            }
            this.ui.lock_icon.addClass('active');
        },
        log_unlocked: function () {
            if (ga) {
                window.ga('send', 'event', 'logsPane', 'Log Unlocked');
            }
            this.ui.lock_icon.removeClass('active');
        },
    });

    export default device_logs_layout;

